import { NgModule } from '@angular/core';
import { MenuModule } from '../menu/menu.module';
import { ApproveandRevokePermanentDOAComponent } from './approvedoa/approveandrevokepermanentdoa.component';
import { HolidayListComponent } from '../../app/admin/holiday_list/holiday_list.component';
import { UpdategrantorComponent } from '../../app/admin/updategrantor/updategrantor.component';
import { UpdatedoacategoriesComponent } from './updatedoacategories/updatedoacategories.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PermanentdoaadminComponent } from '../admin/permanentdoaadmin/permanentdoaadmin.component';
import { MaterialModule } from '../material.module';
import { SharedModule } from '../shared.module';
import { AddUpdateHolidayDialogComponent } from './holiday_list/add-update-holiday-dialog/add-update-holiday-dialog.component';

const componentList = [
  ApproveandRevokePermanentDOAComponent,
  HolidayListComponent,
  UpdategrantorComponent,
  UpdatedoacategoriesComponent,
  PermanentdoaadminComponent,
  AddUpdateHolidayDialogComponent
];

@NgModule({
  imports: [MenuModule, SharedModule, MaterialModule, CommonModule],
  declarations: [componentList],
})
export class AdminModule {}
